import type { Dispatch, SetStateAction } from 'react';

import { colors } from '@/features/user-management/data/user-managment.json';
import type { GroupData } from '@/features/user-management/interfaces/interfaces';

interface AppearanceFormProps {
  groupData: GroupData;
  setGroupData: Dispatch<SetStateAction<GroupData>>;
}

export const AppearanceForm = ({ groupData, setGroupData }: AppearanceFormProps) => {
  const handleSubmit = (color: string) => {
    setGroupData({
      ...groupData,
      groupColor: color,
    });
  };

  const ColorOption = ({ color, selected }: any) => {
    return (
      <div
        className={`cursor-pointer rounded-full ${selected && 'border-4'} w-8 h-8`}
        style={{
          backgroundColor: color,
        }}
        onClick={() => handleSubmit(color)}
      />
    );
  };

  return (
    <div className="flex flex-col gap-2 py-5">
      <div className="flex gap-[13px]">
        {colors.map((color: string) => (
          <ColorOption color={color} key={color} selected={groupData.groupColor === color} />
        ))}
      </div>
      <small className="text-gray-400">Select a color to identify the group</small>
    </div>
  );
};
